__turbopack_context__.v({
  "root": "tweet-link-module__oos2ka__root",
});
